<div class="image-gallery-container" *ngIf="images && images.length > 0">
  <div [class]="getGridClass()">
    <div *ngFor="let image of displayImages; let i = index; trackBy: trackByUrl" class="gallery-item"
      (click)="openImageViewer(i)" [ngClass]="{ 'full-width-image': takeFullWidth && images.length === 1 }">
      <div class="image-container">
        <img [src]="takeFullWidth && images.length === 1 ? image.largeUrl : image.thumbUrl" [alt]="image.filename" class="gallery-image">
        <div class="image-overlay">
          <div class="image-info">
            <i class="ti ti-zoom-in"></i>
            <p class="image-filename">{{ image.filename }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>